<template>

  <Modal modalClass="SimulateurIFC__modal">

    <template v-slot:title>J'effectue<br/><strong>une estimation de mon remboursement IFC</strong></template>

    <form :action="$officeRoute('avocat.simulateur_ifc.post')" method="post" @submit.prevent="submit" class="Form">

      <Input
          v-model="form.anciennete"
          :error="form.errors.anciennete"
          type="number"
          label="Ancienneté dans la profession au moment du départ à la retraite (nombre d'années complètes) : "
          name="anciennete"
          :required="true"
      />

      <Input
          v-model="form.salaireBrutMoyenMensuel"
          :error="form.errors.salaireBrutMoyenMensuel"
          label="Salaire brut moyen mensuel à la date du départ à la retraite : "
          type="number"
          :min="1"
          :required="true"
      />

      <div class="Form__actions">
        <Button
            type="submit"
            :disabled="form.processing"
            class="is--green"
        >
          Je calcule
        </Button>
      </div>

      <template v-if="$page.props.flash?.simulateur_ifc">

        <p>
          Ceci est un exemple de simulation pour un employé au salaire mensuel brut de <strong>{{ formatCurrency(simulateur_ifc.salaireBrutMoyenMensuel) }}</strong>
          pour une cessation d'activité en <strong>{{ simulateur_ifc.year }}</strong>,
          dont l'ancienneté est de <strong>{{ simulateur_ifc.anciennete }} an(s)</strong>.
        </p>

        <div class="results">

          <div>
            <span class="title">Montant remboursé par KERIALIS : </span>
            <span class="amount">{{ formatCurrency(simulateur_ifc.resultat_indemnite) }} **</span>
            <span class="legend">(Nombre de mois de salaire estimé : <strong>{{ simulateur_ifc.coefficientSalaire }}</strong>)</span>
          </div>

          <div>
            <span><u>Soit :</u> Salaire moyen (limité à 3 PMSS***) X Nombre de mois de salaire défini selon son ancienneté </span>
          </div>

        </div>

        <div class="disclaimer">
            <strong>Le remboursement de l'Indemnité de Fin de Carrière sera complété par la prise en charge des cotisations patronales afférentes (ou de la contribution URSSAF en cas de mise à la retraite).</strong>
            <ul>
              <li><strong>*</strong> Champs requis.</li>
              <li><strong>**</strong> Ce calcul est une estimation du montant versé par KERIALIS selon son règlement en vigueur, et ne peut en aucun cas se substituer aux obligations conventionnelles et/ou légales qui incombent à l'employeur pour déterminer le droit à Indemnité de Fin de Carrière auquel pourrait prétendre l'intéressé. Ce montant est fourni sous toutes réserves, selon les éléments déclarés, et dans l'attente de justificatifs nécessaires au traitement complet du dossier.</li>
              <li><strong>***</strong> La limitation à 3 PMSS (Plafonds Mensuels Sécurité Sociale) appliquée par ce simulateur est basée sur le PMSS en vigueur en {{ simulateur_ifc.year }} (soit {{ formatCurrency(simulateur_ifc.PMSS) }}) et sur un salaire moyen à temps complet. Il conviendra de proratiser ce plafond en présence de temps partiel.</li>
            </ul>
        </div>
      </template>
      <template v-else>
        <div class="disclaimer">
          <ul>
            <li><strong>*</strong> Champs requis.</li>
          </ul>
        </div>
      </template>

    </form>
  </Modal>

</template>

<script>
import Modal from '@components/Modal'
import Input from "@components/form/Input";
import {useForm} from "@inertiajs/inertia-vue3";
import Button from "@components/navigation/Button";
import Date from "@components/form/Date";
import {formatCurrency, officeRoute} from "@/helpers";
import {ref} from "vue";
import {Inertia} from "@inertiajs/inertia";

export default {
  components: {Input, Date, Modal, Button },
  setup() {

    const simulateur_ifc = ref(null);

    const form = useForm({
      anciennete: null,
      salaireBrutMoyenMensuel: null,
    });

    const submit = () => {
      form.post(officeRoute('avocat.simulateur_ifc.post'), {
        onSuccess: () => {
          simulateur_ifc.value = Inertia.page.props.flash.simulateur_ifc
        }
      })
    }

    return {
      form,
      submit,
      formatCurrency,
      simulateur_ifc
    }

  },
}
</script>

<style lang="scss">
  @import "~@sass/components/_SimulateurIFCModal.scss";
</style>
